<template>
  <page-view title="粉兔朋友圈助手">
    <div slot="headerContent">
      <!-- <p style="font-size: 14px;color: rgba(0,0,0,.65)">{{ description }}</p> -->
      <div class="link" :style="{marginBottom:'20px'}">
        <a-button type="primary" @click="handleConnectFentu" :loading="connectFentuLoading">创建粉兔账户</a-button>
        <a-button type="link" v-show="spread">
          <a :href="'https://www.yuque.com/docs/share/9c743d4e-7377-4e0e-a0b3-709e4595749c?#'" target="_blank">
            <span>使用教程</span>
          </a>
        </a-button>
      </div>
    </div>
    <div slot="extra">
      <div class="extra-img">
        <img v-if="typeof extraImage !== 'undefined'" :src="extraImage" />
      </div>
    </div>
    <div ref="content">
      <!-- <a-empty
        image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
      >
        <span slot="description"> 即将开放 </span>
      </a-empty>-->
      <!-- <div class="account-container">
111
      </div>-->
      <a-spin :spinning="!activation" tip="请先点击左上角“创建账户”">
        <iframe
          class="fentu-iframe"
          :src="'https://fentu.duomai.com/fentu/dashboard#/login'"
        ></iframe>
      </a-spin>
    </div>
  </page-view>
</template>

<script>
import TripartiteFentuApi from '@/api/tripartite-fentu'
import moment from 'moment'
import { PageView } from '@/layouts'
export default {
  name: 'TripartiteFentu',
  components: {
    PageView
  },
  data() {
    return {
      description: '杭州多谦网络科技有限公司',
      extraImage: 'https://gw.alipayobjects.com/zos/rmsportal/RzwpdLnhmvDJToTdfDPe.png',
      dataSource: [],
      pagination: {
        pageSize: 200,
        current: 0
      },
      activation: false,
      whole: false,
      connectFentuLoading: false
    }
  },
  computed: {
    spread() {
      return this.$store.state.brand.spread
    }
  },
  created() {},
  methods: {
    handleConnectFentu() {
      this.connectFentuLoading = true
      TripartiteFentuApi.getFentuAccount({})
        .then(res => {
          if (res.code === 1) {
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.connectFentuLoading = false
          setTimeout(() => {
            this.activation = true
          }, 1000);
        })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 24px 24px 0;
  .link {
    margin-top: 16px;
    &:not(:empty) {
      margin-bottom: 16px;
    }
    a {
      margin-right: 32px;
      height: 24px;
      line-height: 24px;
      display: inline-block;
      i {
        font-size: 24px;
        margin-right: 8px;
        vertical-align: middle;
      }
      span {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.page-menu-search {
  text-align: center;
  margin-bottom: 16px;
}
.page-menu-tabs {
  margin-top: 48px;
}

.extra-img {
  margin-top: -60px;
  text-align: center;
  width: 195px;

  img {
    width: 100%;
  }
}

.mobile {
  .extra-img {
    margin-top: 0;
    text-align: center;
    width: 96px;

    img {
      width: 100%;
    }
  }
}

.meta-content {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  height: 80px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.fentu-iframe {
  border: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 1000px;
}

.account-container {
  width: 100%;
  height: 100px;
  background: #ffffff;
  margin-bottom: 20px;
}
</style>
